import React, { FC, useEffect } from 'react';
import { RepairShop } from '../../../api/models/RepairShop';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { Calendar, ExpandChevron, Phone } from '../../../utils/Icons';
import TransparentButton from '../../../Inputs/components/TransparentButton/TransparentButton';
import useIsMobile from '../../../utils/use-is-mobile';
import { useScrollingHelper } from '../../../utils/scrolling-helper';
import styles from './ShopItem.module.scss';

export interface ShopItemProps {
  shop: RepairShop;
  expanded: boolean;
  onExpand: (id: string) => void;
}

const ShopItem: FC<ShopItemProps> = ({ shop, expanded, onExpand }) => {
  const isMobile = useIsMobile();
  const scrollTo = useScrollingHelper();

  const detailsRef = React.useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (expanded && detailsRef.current) {
      setTimeout(() => scrollTo(detailsRef, 'bottom'), 200);
    }
  }, [expanded]);

  const handleCall = (text: string) => {
    navigator.clipboard.writeText(text).then(result => console.log('then', result));

    if (isMobile) {
      window.open(`tel:${text}`);
    }
  };

  return (
    <Accordion expanded={expanded} onChange={() => onExpand(shop.id)} disableGutters>
      <AccordionSummary className={styles.shopSummary} expandIcon={<ExpandChevron />}>
        <div className={styles.shopIndicator}>{shop.order + 1}</div>
        <p>{shop.name}</p>
      </AccordionSummary>
      <AccordionDetails className={styles.shopDetailsContainer} ref={detailsRef}>
        <div className={styles.shopDetails}>
          <p>{shop.address}</p>
          <p>
            {shop.postalCode} {shop.postOffice}
          </p>
          <TransparentButton
            icon={<Phone />}
            onClick={() => handleCall(shop.phoneNumber)}
            text={`Soita ${shop.phoneNumber}`}
          ></TransparentButton>
          <TransparentButton
            icon={<Calendar />}
            onClick={() => {
              window.open(shop.reservationLink, '_blank');
            }}
            text={`Varaa aika`}
          ></TransparentButton>
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

export default ShopItem;
